import { AxiosInstance } from 'axios';
import * as DepartureReportService from './services';

export type DepartureReportServiceType = ReturnType<typeof DepartureReportService.exportPDF>;

export const initDepartureReportService = (axios: AxiosInstance): DepartureReportServiceType =>
  DepartureReportService.exportPDF(axios);
